export default __webpack_public_path__ + "static/media/59.36e64307.png";